import styled from "@emotion/styled";
import { List as MuiList } from "@mui/material";

const ChildList = styled(MuiList)({
  padding: "0px 0px 0px 16px !important",
  margin: 0,
  width: "100%",
});

export default ChildList;